// extracted by mini-css-extract-plugin
export default {"container":"user-guardians_container__N94rS","headerContainer":"user-guardians_headerContainer__8-gXe"};